import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';

export const useCampaignGroupEnabled = () => useConfigMatch({ [FEATURE_FLAGS.CAMPAIGN_GROUP_ENABLED]: 'true' });
